import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { useSpring, animated } from 'react-spring';

const BoxMessage = styled('div')`
  display: flex;
  justify-content: center;
  padding: 5px;
  font-style: italic;
  font-size: 14px;
`;

const Wrapper = styled('div')`
  margin-bottom: 10px;
`;

const IsTypingComponent = ({ feedObject }) => {
  const isTyping = useSelector((state) => state.feed.data.isTyping);
  const typingObject = useSelector((state) => state.feed.data.typingObject);
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const [isOpened, setIsOpened] = useState(false);

  const TypingBoxDiv = useSpring({
    height: isOpened ? '25px' : '0px',
    opacity: isOpened ? 1 : 0,
  });

  const handleTypingStateChange = () => {
    if (isTyping && typingObject?.postId === feedObject?.id
      && typingObject?.userId !== currentUser?.id) {
      setIsOpened(true);
    } else {
      setIsOpened(false);
    }
  };

  useEffect(() => {
    handleTypingStateChange();
  }, [isTyping, typingObject, feedObject?.id, currentUser?.id]);

  return (
    <Wrapper>
      <animated.div style={TypingBoxDiv}>
        <BoxMessage>Someone is typing...</BoxMessage>
      </animated.div>
    </Wrapper>
  );
};

IsTypingComponent.propTypes = {
  feedObject: PropTypes.instanceOf(Object).isRequired,
};

export default IsTypingComponent;
